/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Font_Name_PlaceholderInputs */

const en_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter Font Name`)
};

const fr_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir le nom de la police`)
};

const de_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftart eingeben`)
};

const it_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il nome del font`)
};

const ru_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название шрифта`)
};

const es_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca el nombre de la fuente`)
};

const zh_cn2_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入字体名称`)
};

const ja_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォント名を入力`)
};

const hi_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट का नाम दर्ज करें`)
};

const pt_pt2_options_fonts_font_name_placeholder = /** @type {(inputs: Options_Fonts_Font_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite o nome da fonte`)
};

/**
* | output |
* | --- |
* | "Enter Font Name" |
*
* @param {Options_Fonts_Font_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_font_name_placeholder = /** @type {((inputs?: Options_Fonts_Font_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Font_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_font_name_placeholder(inputs)
	if (locale === "de") return de_options_fonts_font_name_placeholder(inputs)
	if (locale === "it") return it_options_fonts_font_name_placeholder(inputs)
	if (locale === "ru") return ru_options_fonts_font_name_placeholder(inputs)
	if (locale === "es") return es_options_fonts_font_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_font_name_placeholder(inputs)
	if (locale === "ja") return ja_options_fonts_font_name_placeholder(inputs)
	if (locale === "hi") return hi_options_fonts_font_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_font_name_placeholder(inputs)
	return en_options_fonts_font_name_placeholder(inputs)
});